import axios from 'axios'
import { useEffect, useState } from 'react'
import { Get_Features } from '../api/api'

const useFeatureList = () => {
  const [features, setFeatures] = useState(null)

  useEffect(() => {
    const getFeatures = async () => {
      try {
        const res = await axios.get(Get_Features)
        setFeatures(res.data)
      } catch (error) {
        setFeatures(false)
      }
    }
    getFeatures()
  }, [])

  return features
}

export default useFeatureList
